import { MobileLoginGuard } from '../../mobile-login.guard';
import { MicrosoftLoginGuard } from '../../microsoft-login.guard';

const MOBILE_UA =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i;

const isMobile = MOBILE_UA.test(navigator.userAgent);

export const ROUTE_GUARDS = isMobile ? [MobileLoginGuard] : [MicrosoftLoginGuard];
